import { ErrorPayload } from '../common/types';
import { ThunkParams } from '../types';
import { getLLMPromptsActions, getLLMPromptByIdActions, createLLMPromptActions, updateLLMPromptActions, deleteLLMPromptActions } from './llmPromptsActions';
import { LLMPrompt, CreateLLMPromptRequest, UpdateLLMPromptRequest } from './llmPromptsTypes';

// Get all LLM prompts
function processGetLLMPromptsSuccess(payload: LLMPrompt[]) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getLLMPromptsActions.success(payload));
  };
}

function processGetLLMPromptsFail(error: ErrorPayload) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getLLMPromptsActions.fail(error));
  };
}

export function getLLMPromptsThunk() {
  return async function (dispatch: Function, getState: Function, { apiClient }: ThunkParams): Promise<any> {
    dispatch(getLLMPromptsActions.start());
    return apiClient.get('v1/llmPrompt', {
      auth: true,
      successAction: processGetLLMPromptsSuccess,
      failAction: processGetLLMPromptsFail
    });
  };
}

// Get LLM prompt by ID
function processGetLLMPromptByIdSuccess(payload: LLMPrompt) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getLLMPromptByIdActions.success(payload));
  };
}

function processGetLLMPromptByIdFail(error: ErrorPayload) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getLLMPromptByIdActions.fail(error));
  };
}

export function getLLMPromptByIdThunk(promptId: string) {
  return async function (dispatch: Function, getState: Function, { apiClient }: ThunkParams): Promise<any> {
    dispatch(getLLMPromptByIdActions.start());
    return apiClient.get(`v1/llmPrompt/${promptId}`, {
      auth: true,
      successAction: processGetLLMPromptByIdSuccess,
      failAction: processGetLLMPromptByIdFail
    });
  };
}

// Create LLM prompt
function processCreateLLMPromptSuccess(payload: LLMPrompt) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(createLLMPromptActions.success(payload));
  };
}

function processCreateLLMPromptFail(error: ErrorPayload) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(createLLMPromptActions.fail(error));
  };
}

export function createLLMPromptThunk(request: CreateLLMPromptRequest) {
  return async function (dispatch: Function, getState: Function, { apiClient }: ThunkParams): Promise<any> {
    dispatch(createLLMPromptActions.start());
    return apiClient.post('v1/llmPrompt', {
      auth: true,
      data: request,
      successAction: processCreateLLMPromptSuccess,
      failAction: processCreateLLMPromptFail
    });
  };
}

// Update LLM prompt
function processUpdateLLMPromptSuccess(payload: LLMPrompt) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(updateLLMPromptActions.success(payload));
  };
}

function processUpdateLLMPromptFail(error: ErrorPayload) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(updateLLMPromptActions.fail(error));
  };
}

export function updateLLMPromptThunk(request: UpdateLLMPromptRequest) {
  return async function (dispatch: Function, getState: Function, { apiClient }: ThunkParams): Promise<any> {
    dispatch(updateLLMPromptActions.start());
    return apiClient.put(`v1/llmPrompt/${request.id}`, {
      auth: true,
      data: request,
      successAction: processUpdateLLMPromptSuccess,
      failAction: processUpdateLLMPromptFail
    });
  };
}

// Delete LLM prompt
function processDeleteLLMPromptSuccess(promptId: string) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(deleteLLMPromptActions.success(promptId));
  };
}

function processDeleteLLMPromptFail(error: ErrorPayload) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(deleteLLMPromptActions.fail(error));
  };
}

export function deleteLLMPromptThunk(promptId: string) {
  return async function (dispatch: Function, getState: Function, { apiClient }: ThunkParams): Promise<any> {
    dispatch(deleteLLMPromptActions.start());
    return apiClient.delete(`v1/llmPrompt/${promptId}`, {
      auth: true,
      successAction: () => processDeleteLLMPromptSuccess(promptId),
      failAction: processDeleteLLMPromptFail
    });
  };
}
